import type { KizenNodeType, Step } from 'pages/AutomationEngine/types';
import { KIZEN_PREFIX, LocalStorage } from './Storage';

type AutomationCopyLocalStorageStep = {
  contextObjectId: string;
  automationId: string;
  step: Step;
  type: KizenNodeType;
};

const AUTOMATION_COPY_KEY = `${KIZEN_PREFIX}automation-copy`;

class AutomationCopyLocalStorage extends LocalStorage {
  private automationScopedStepTypes = new Set<KizenNodeType>([
    'go_to_automation_step',
  ]);

  constructor(
    key: string,
    { serialize = JSON.stringify, deserialize = JSON.parse } = {}
  ) {
    super(key, { serialize, deserialize });
  }

  set step({
    contextObjectId = 'global',
    automationId,
    step,
    type,
  }: AutomationCopyLocalStorageStep) {
    const val = {
      ...this.val,
      [contextObjectId]: { step, type, automationId },
    };
    this.val = val;
  }

  stepByContextObjectId = (
    contextObjectId: string = 'global',
    automationId: string
  ) => {
    const stepData: AutomationCopyLocalStorageStep | undefined =
      this.val?.[contextObjectId];
    if (
      stepData?.type &&
      this.automationScopedStepTypes.has(stepData.type) &&
      stepData.automationId !== automationId
    ) {
      return undefined;
    }
    return stepData;
  };
}

export const automationCopyLocalStorage = new AutomationCopyLocalStorage(
  AUTOMATION_COPY_KEY
);
